<template>
  <div style="width: 94% !important; margin-left: 3% !important">
    <v-card-text
      class="common-datepicker py-0 px-0"
      :class="isSmallDevice ? 'small-device' : ''"
    >
      <v-col
        class="py-0 px-0"
        cols="6"
        style="
          font-weight: bold !important;
          display: inline-flex !important;
          vertical-align: top !important;
          margin-top: 6px !important;
        "
      >
        {{ labelName }}
      </v-col>
      <v-col
        cols="6"
        class="py-0 px-0"
        style="font-size: 0.85rem; display: inline-flex !important"
      >
        <v-menu
          v-model="commonDatePicker"
          :close-on-content-click="false"
          :nudge-right="100"
          transition="scale-transition"
          offset-y
          :rules="[(v) => !!v || 'Bitte wählen Sie das Stelldatum']"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :disabled="!isClickable"
              v-model="commonDateFormatted"
              append-icon="mdi-calendar-clock"
              :label="itemMessage"
              readonly
              v-bind="attrs"
              v-on="on"
              :rules="[(v) => !!v || '']"
            ></v-text-field>
          </template>
          <v-date-picker
            locale="de"
            :first-day-of-week="1"
            v-model="commonDate"
            @input="setCommonDate()"
            :allowed-dates="allowedDates"
            :min="minimumDate"
            style="font-size: 0.85rem"
            data-cy="datePicker"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-card-text>
  </div>
</template>
<script>
import Vue from "vue";
import { dateFormat } from "@/helpers";

export default Vue.extend({
  props: {
    labelName: String,
    isClickable: Boolean,
    itemMessage: String,
    isSmallDevice: Boolean,
  },
  data: () => {
    return {
      commonDatePicker: false,
      commonDateFormatted: "",
      commonDate: "",
    };
  },
  methods: {
    setCommonDate() {
      this.commonDateFormatted = dateFormat(this.commonDate);
      this.$emit("set-date-value", this.commonDate);
      this.commonDatePicker = false;
    },
    allowedDates: (val) => new Date(val).getDay() % 6,
  },
  computed: {
    minimumDate() {
      const maximumTimeDate = new Date();
      maximumTimeDate.setHours(12, 0, 0);
      const currentTimeDate = new Date();
      if (currentTimeDate >= maximumTimeDate || currentTimeDate.getDay() === 6 || currentTimeDate.getDay() === 0) {
        if(currentTimeDate.getDay() > 4){
          currentTimeDate.setDate(currentTimeDate.getDate() + (currentTimeDate.getDay() === 5 ? 4 : 3));
        }else{
          currentTimeDate.setDate(currentTimeDate.getDate() + 2);
        }
      }else{
        currentTimeDate.setDate(currentTimeDate.getDate() + 1);
      }
      return currentTimeDate.toISOString();
    },
  },
});
</script>

<style lang="css" scoped>
.common-datepicker >>> .v-text-field input {
  font-size: 0.85rem !important;
  text-align: right;
}
.common-datepicker >>> .v-text-field {
  padding-top: 0px !important;
  margin-top: 0px !important;
}

.common-datepicker >>> .v-icon {
  font-size: 1.25rem !important;
}

.common-datepicker >>> .v-label {
  font-size: 0.85rem !important;
  max-width: 100% !important;
  color: #9e9e9e;
  right: 0px !important;
  left: auto !important;
}
.common-datepicker >>> .v-label--active {
  display: none !important;
}
.common-datepicker >>> .v-input__slot {
  margin-bottom: 5px !important;
}
.common-datepicker >>> .v-input__slot:before {
  border-style: none !important;
}
.common-datepicker >>> .v-text-field__details {
  margin-top: -15px !important;
  width: 80% !important;
  margin-left: 5%;
}
.common-datepicker >>> .v-input__slot:after {
  border-style: none !important;
}
.common-datepicker >>> .v-text-field__details {
  display: none !important;
}
.common-datepicker.small-device >>> * {
  font-size: 0.8rem !important;
}
.small-device >>> .v-icon {
  font-size: 1.25rem !important;
}
</style>
